// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1oUz4","name":"ConsentHeader_name__2eaf1","birthday":"ConsentHeader_birthday__bGLIK","skeleton":"ConsentHeader_skeleton__3oDVU"};